import { render, staticRenderFns } from "./accountset.vue?vue&type=template&id=55689e54&scoped=true"
import script from "./accountset.vue?vue&type=script&lang=js"
export * from "./accountset.vue?vue&type=script&lang=js"
import style0 from "./accountset.vue?vue&type=style&index=0&id=55689e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55689e54",
  null
  
)

export default component.exports